import { ReactComponent as LightningIcon } from "atoms/icons/lightning.svg";
import { cn } from "@/shadcn/lib/utils";

type QuickActionsMenuButtonProps = {
  disabled: boolean;
  label: string;
  open: boolean;
};

export const QuickActionsMenuButton = ({ disabled, label, open }: QuickActionsMenuButtonProps) => {
  return (
    <span className="flex justify-end">
      <span
        className={cn(
          "relative flex h-10 w-12 items-center overflow-hidden rounded-l-full py-2 pr-4 pl-4 transition-all",
          !disabled && "hover:w-40",
          disabled && "cursor-not-allowed opacity-30",
          open ? "w-40 bg-primary-light text-primary" : "bg-primary text-primary-foreground",
        )}
        data-testid="quickActionOpenTrigger"
      >
        <span className="type-body-sm font-bold whitespace-nowrap">{label}</span>
        <span className="absolute right-0 bg-inherit pr-4 pl-2">
          <LightningIcon />
        </span>
      </span>
    </span>
  );
};
